import { makeAutoObservable } from 'mobx';
import { getOnePieceServerApi } from 'gql-ops';
import { UserMission } from 'gql-ops/graph/__generated__/request';
import user from './user';

class MissionStore {
    missions: UserMission[] = [];
    loading: boolean = false;
    error: string | null = null;
    canMint: boolean = false;
    holdYesterdayNFTPiece?: boolean | null = null;
    twitterComboAction: boolean = false;
    claimGasStatus: string = 'NotEligible'; // 'NotEligible' | 'Eligible' | 'Completed' | 'DailyCapExceeded' =
    constructor() {
        makeAutoObservable(this);
    }

    async fetchMissions() {
        if (!user.address) return;

        this.loading = true;
        this.error = null;
        try {
            const res = await getOnePieceServerApi().userMissions({ address: user.address });
            this.missions = (res.userMissions || []).map((mission) => ({
                ...mission,
                id: Number(mission.id),
                type: mission.type,
                meta: mission.meta || {},
            })) as UserMission[];
        } catch (error) {
            console.error('Failed to fetch missions:', error);
            this.error = 'Failed to fetch missions';
            this.missions = [];
        } finally {
            this.loading = false;
        }
    }

    get currentDayIndex(): number | undefined {
        // 优先从 localStorage 获取 dayIndex
        const storedDayIndex = localStorage.getItem('dayIndex');
        if (storedDayIndex !== null) {
            return Number(storedDayIndex);
        }

        // 如果 localStorage 中没有，则从 missions 中获取
        const todayMission = this.missions[0];
        if (!todayMission) {
            return undefined;
        }
        return todayMission.dayIndex;
    }

    updateMission(mission: UserMission) {
        const index = this.missions.findIndex((m) => m.id === mission.id);
        if (index > -1) {
            this.missions[index] = mission;
        }
    }
}

const missionStore = new MissionStore();
export default missionStore;
